import { useCallback, useMemo } from 'react';

import { Button } from 'app/shared/buttons/Button';
import { WalletMobileTag } from 'app/shared/LoginForm/components/connections/CosmosKitWallets/WalletsModal';
import { Spinner } from 'app/shared/misc/Spinner';
import { WALLETS_INFO } from 'app/constants/wallets';
import { useAuthentication } from 'app/hooks/useAuthentication';

import { Modal } from '../Modal/Modal';

export const AuthStatus = () => {
  const {providerPreview, state, connected} = useAuthentication();

  if (
    !providerPreview &&
    (connected || state === 'none' || state === 'initialized')
  ) {
    return null;
  }

  return <Render />;
};

const Render = () => {
  const {
    provider: originalProvider,
    providerPreview,
    disconnect,
  } = useAuthentication();

  const provider = originalProvider ?? providerPreview;

  const onClickCancel = useCallback(() => {
    disconnect();
  }, [disconnect]);

  const walletInfo = useMemo(() => {
    const type =
      provider?.loginProvider ?? provider?.walletType ?? provider?.type;

    if (!type) {
      return {
        name: 'Wallet',
      };
    }

    return WALLETS_INFO[type];
  }, [provider]);

  const {Icon, isMobile, name} = walletInfo;

  return (
    <Modal
      className="w-full max-w-[400px]"
      animation="fade"
      isOpen
      hideCloseButton
      cancellable={false}>
      <div className="flex flex-col items-center space-y-8 p-4">
        <h2 className="text-xl font-medium leading-normal">Connecting to</h2>

        {Icon ? (
          <div className="mt-4 flex items-center justify-center gap-2">
            <Icon className="mr-1 h-[50px] w-[50px]" />
            <h3 className="text-[22px] font-normal">{walletInfo.name}</h3>
            {isMobile && <WalletMobileTag />}
          </div>
        ) : (
          name
        )}

        <Spinner size="small" />

        <div className="flex flex-col items-center space-y-6">
          <p className="mt-2.5 text-xs text-white">
            {/* web3auth */}
            {provider?.loginProvider && (
              <>
                {provider?.loginProvider === 'email_passwordless' ? (
                  <>Check your email to approve the connection.</>
                ) : (
                  <>Authorize the connection in the popup window.</>
                )}
              </>
            )}

            {/* cosmos-kit */}
            {provider?.walletType &&
              'Check your wallet for a connection request.'}
          </p>

          <Button
            variant="secondary-gray-contained"
            size="md"
            onClick={onClickCancel}>
            Cancel Connection
          </Button>
        </div>
      </div>
    </Modal>
  );
};
